// extracted by mini-css-extract-plugin
export default {"wrapper":"bubble-chart_wrapper__dQwmI","container":"bubble-chart_container__F43PV","legend":"bubble-chart_legend__X9kp8"};